module.exports = __webpack_public_path__ + "ic_favicon.620e1109.png";